import type { IconSvgObject } from './types';

const AxisThreeDIcon: IconSvgObject = [
  ["path", { d: "M3 3V19C3 20.1046 3.89543 21 5 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 20L5.5 18.5M8.5 15.5L9.5 14.5M12.5 11.5L13.5 10.5M16 8L17 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AxisThreeDIcon;
